import Icon, { IconProps } from './Icon';
import { QuestionCircleOutlined as QuestionIcon } from '@ant-design/icons'

const QuestionCircleOutlined: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <QuestionIcon />
        </Icon>
    );
};

export default QuestionCircleOutlined;
